module.exports = "/assets/dist/images/coupe_wide.jpg?d594720d3c4fe76e9b0454e076a750c2";